import { TFunction } from "react-i18next";
import { Link } from "react-router-dom";
import { getMonthName } from "go-core/components/Formatters/FormatDate";
import { OrganizationState } from "go-security/services/organizations/types";
import { ReportGroup } from "./types";

export const getBasicGroups = (t: TFunction, organizationId?: number) => {
	const basicGroups: ReportGroup[] = [
		{
			id: "PRODUCT",
			name: t("common.word.product"),
		},
		{
			id: "STOCK",
			name: t("common.word.stock"),
		},
		{
			id: "PRODUCT_CATEGORY",
			name: t("common.word.product_category"),
		},
		{
			id: "DATE",
			name: t("common.word.date", { ns: "lib" }),
		},
		{
			id: "YEAR",
			name: t("modules.state_report.field.year.title"),
		},
		{
			id: "MONTH",
			name: t("modules.state_report.field.month.title"),
		},
		{
			id: "DAY_OF_MONTH",
			name: t("modules.state_report.field.day.title"),
		},
	];
	if (!organizationId)
		basicGroups.push({
			id: "ORGANIZATION",
			name: t("common.word.organization"),
		});

	return basicGroups;
};

export const getBasicGroupsInfo = (t: TFunction, organization: OrganizationState) => ({
	PRODUCT: (groupByValue: Record<string, any>) => (
		<Link rel={"noreferrer"} target={"_blank"} to={`/${organization.id}/products/${groupByValue.id}/edit`}>
			{groupByValue.name}
		</Link>
	),
	MONTH: (groupByValue: Record<string, any>) => {
		if (!groupByValue.name) return "";
		return getMonthName(groupByValue.name, t);
	},
});

export const getCommonCommentFilter = (t: TFunction) => ({
	id: "comments",
	name: t("common.word.comment.title"),
	type: "text",
});
